/**
 * EWBCI API Client の定数定義
 */

/**
 * デフォルトのポーリング間隔（ミリ秒）
 */
export const DEFAULT_POLLING_INTERVAL = 1000;

/**
 * デフォルトのタイムアウト時間（ミリ秒）
 */
export const DEFAULT_TIMEOUT = 30000;

/**
 * サブスクライブ要求のデフォルトタイムアウト（ミリ秒）
 */
export const SUBSCRIBE_TIMEOUT = 30000;

/**
 * DGTトークン取得のデフォルトタイムアウト（ミリ秒）
 */
export const DGT_TOKEN_TIMEOUT = 10000;

/**
 * チャンクメッセージの最大サイズ
 */
export const MAX_CHUNK_SIZE = 1024 * 1024; // 1MB

/**
 * ポーリング間隔の最小値（ミリ秒）
 */
export const MIN_POLLING_INTERVAL = 100;

/**
 * ポーリング間隔の最大値（ミリ秒）
 */
export const MAX_POLLING_INTERVAL = 10000;

/**
 * ログ用のコンポーネント名
 */
export const LOG_COMPONENT = 'EWBCIClient';
